var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog307(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_307",
    "data-name": 307,
    className: "cls-1",
    d: "M58.67,1.84C44.38-.88,35.06,16.08,30.43,28.61,24.14,45.61,18,95,43.82,98.35c25.57,3.37,34.92-48.48,30.6-68.27C73.22,24.56,68.67,3.74,58.67,1.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog307);
export default __webpack_public_path__ + "static/media/dog_307.60fdc78e56590cfa630ea44930934dc5.svg";
export { ForwardRef as ReactComponent };